import styled, { css } from 'styled-components';

export const InputAndSearchSection = styled.div`
  padding: 40px 0 40px 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 736px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const SelectTestLabel = styled.label`
  width: 95px;
`;

export const DateLabel = styled.label`
  width: 120px;
`;

export const InputSection = styled.div`
  display: flex;
  align-items: end;
`;

export const FeedbackContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  padding: 1rem !important;
  font-size: 14px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FeedbackCard = styled.div`
  position: relative;
  display: block;
  margin-bottom: 0.75rem;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 0.25rem;
  box-shadow: 0 5px 15px rgb(0 0 0 / 30%);
  padding: 15px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const LabelContainer = styled.div`
  display: flex;
  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
`;

export const QuestionContainer = styled.div`
  display: grid;
`;

export const LabelHeading = styled.label`
  font-weight: 600;
`;

export const AnswerLabel = styled.label`
  margin-left: 27px;
`;

export const HorizontalLine = styled.hr``;

export const FeedbackCheckbox = styled.div`
  margin-left: 0.25rem !important;
  display: inline-flex;
`;

export const FeedbackInputCheckbox = styled.input`
  height: 20px;
  width: 20px;
  cursor: pointer;
`;

export const CanvasContainer = styled.div`
  padding: 40px;
  width: 70%;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 10px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;
